export const it = {
  Login: 'Accedi',
  success: 'Fatto con successo!',
  NovalidEmailPass: 'Email o password non valida',
  Next: 'Avanti',
  Day: 'GG',
  Month: 'MM',
  Year: 'AAAA',
  January: 'Gennaio',
  February: 'Febbraio',
  March: 'Marzo',
  April: 'Aprile',
  May: 'Maggio',
  June: 'Giugno',
  July: 'Luglio',
  August: 'Agosto',
  September: 'Settembre',
  October: 'Ottobre',
  November: 'Novembre',
  December: 'Dicembre',
  Accept: 'Accetto',
  Agree: 'Acconsento',
  Nagree: 'Non acconsento',
  Yes: 'Si',
  No: 'No',
  NoThanks: 'No, grazie.',
  Ihave: 'Attiva una card MyPass Sci',
  Idonthave: 'Non ho una card MyPass Sci',
  Allareas: 'Tutti i comprensori convenzionati con MyPass',
  Withdraw: 'Ritiro in comprensorio',
  Ship: 'Spedizione a casa',
  Male: 'M',
  Female: 'F',
  Parent: 'Accetto in quanto genitore o tutore',
  Apply: 'Applica',
  Resend: 'Reinvia Email',
  Wrong: 'Correggi Email',
  Tab1: 'Sciatori & Cards',
  Tab2: 'Movimenti',
  Tab3: 'Metodi di pagamento',
  Tab4: 'Privacy',
  Tab5: 'Assistenza',
  Fullname: 'Nome e Cognome:',
  Born: 'Nato il:',
  Status: 'Stato servizio:',
  Renewal: 'Rinnovo automatico:',
  Activate: 'Da attivare',
  Active: 'Attivo fino al',
  Expired: 'Scaduto il',
  Upload: 'Carica',
  Uploaddoc: 'Carica doc.',
  Cardactivate: 'CARD DA ATTIVARE',
  Insert: 'Inserisci il numero della card',
  Activatecard: 'Attiva card',
  Adulto: 'Adulto',
  Adult: 'Adulto',
  Senior: 'Senior',
  Junior: 'Junior',
  Baby: 'Bambino',
  Type: 'Tipologia:',
  Blockcard: 'Blocca card',
  Replacecard: 'Richiedi card sostitutiva',
  Cardblocked: 'CARD BLOCCATA',
  Unblockcard: 'Richiedi sblocco card all’assistenza',
  Cost: 'La card sostitutiva ha un costo di 5€',
  Requestpa: 'Richiedi card (Paganella)',
  Requestnpa: 'Richiedi card (No Paganella)',
  Renew: 'Rinnova',
  Addnew: 'Aggiungi nuovo sciatore',
  Contact: 'Per informazioni e ricevere assistenza contattaci come preferisci:',
  Read: 'Consulta le nostre',
  Nouser: 'Non hai ancora alcun sciatore configurato',
  NoMovement: 'Non sono ancora presenti movimenti',
  Insertm: 'Inserisci',
  Nomethod: 'Inserisci metodo di pagamento',
  Edit: 'Modifica',
  Delete: 'Elimina',
  Creditcards: 'Carte di credito:',
  Debitcards: 'Carte di debito:',
  Save: 'Salva',
  Cancel: 'Annulla',
  Cradverify: 'Inseriti gli estremi della carta di credito verranno addebitati ed in seguito stornati 0,10€ per la verifica dei dati.',
  Fullnameinput: 'Nome e Cognome',
  Cardnum: 'N° Carta',
  Nomethodinput: 'Dati della carta di credito', // "Inserisci metodo di pagamento:",
  Initialcookiesprivacy: 'Acconsento al trattamento dei miei dati da parte di MYPASS per finalità di informazione commerciale erogate dalla stessa MYPASS, anche con l’invio di newsletter e l’uso di cookies di profilazione (facoltativo).',
  Initialdataprivacy: 'Acconsento alla cessione dei miei dati da parte di MYPASS a Società partner di MYPASS, per finalità di informazione commerciale erogate da dette Società, anche con uso di cookies di profilazione (facoltativo).',
  Deletea: 'Elimina account',
  Profile: 'Profilo',
  Cellphone: 'Cellulare',
  Changep: 'Modifica password',
  Confirm: 'Conferma',
  Continue: 'Continua',
  Enterop: 'Inserisci la vecchia password',
  Enternp: 'Inserisci la nuova password',
  Newmail: 'Nuova e-mail',
  Yourmail: 'La tua e-mail è',
  Insertmail: 'Inserisci il nuovo indirizzo e-mail.',
  Confirmail: 'Conferma e-mail',
  Insertcode: 'Inserisci il codice di 5 caratteri che hai ricevuto via e-mail.',
  Sureblock: 'Sei sicuro di voler bloccare la tua carta?',
  Byblock: "Potrai sbloccarla solo contattando l'assistenza",
  Seeall: 'Altri pagamenti',
  Retrypayment: 'Ritenta i pagamenti',
  Allmovements: 'Tutti i movimenti',
  Passyear: 'Anno',
  Ok: 'OK',
  Uploadocuments: 'Carica i documenti e la foto per avere diritto alle tariffe scontate',
  Attentionexpired: 'ATTENZIONE! ACCOUNT BLOCCATO PER CARTA DI PAGAMENTO SCADUTA',
  Updatecard: 'AGGIORNA LA CARTA DI PAGAMENTO',
  Attentionsuspended: 'ATTENZIONE! ACCOUNT BLOCCATO PER PAGAMENTI IN SOSPESO',
  Completepayment: 'Completa il pagamento se necessario cambiando la carta di credito',
  Showsuspended: 'MOSTRA PAGAMENTI IN SOSPESO',
  Datamodified: ' ',
  Datamodified_msg: 'Il tuo profilo è stato modificato con successo!',
  Suredelete: 'Sei sicuro di voler eliminare il tuo account?',
  Alleliminate: 'Tutti i dati presenti nell’account verranno eliminati, quindi non sarà più possibile recuperarli.',
  Emailsent: 'E-mail inviata correttamente!',
  Confirmrenew: 'Confermi il rinnovo del servizio MyPass Sci?',
  Charge: 'Sei sicuro di voler rinnovare il servizio?',
  Attention: 'ATTENZIONE!',
  Atleast: 'Per usufruire dei servizi Sci o richiedere una card il titolare dell’Account deve avere almeno 16 anni.',
  Gotit: 'Ok, ho capito',
  Surecancel: 'Sei sicuro di voler annullare la registrazione?',
  Allost: 'Tutti i tuoi dati inseriti fino ad ora non verranno salvati',
  Returnlogin: 'Torna al login',
  Returnsite: 'Torna al sito',
  Alreadyreg: 'Sciatore già registrato.',
  Ifuwant: 'Se vuoi aggiungere un’altra card per questo sciatore puoi farlo nell’area utente al termine della registrazione.',
  Oops: 'OPS! QUALCOSA É ANDATO STORTO!',
  Nosuccess: 'La transazione non è andata a buon fine, riprova. Se il problema persiste contatta l`assistenza',
  Retry: 'Riprova',
  Goto: "Vai all'Area Utente",
  Wespeed: 'NO LINE GOOD TIME',
  Youforget: 'Hai dimenticato la password?',
  Nothave: 'Non hai ancora un account?',
  Signup: 'Registrati',
  Insertdata: 'Inserisci i tuoi dati',
  Name: 'Nome',
  Surname: 'Cognome',
  Email: 'Email',
  Password: 'Password',
  Confirmpass: 'Conferma Password',
  Birthday: 'Data di nascita',
  Necessary: 'La data di nascita è necessaria per verificare che l’utente abbia almeno 16 anni come da normativa in vigore e per usufruire di eventuali agevolazioni e sconti',
  RemoveCard: 'Sei sicuro di voler rimuovere questa carta?',
  Err_maxNumberExeeds: 'Il numero massimo di carte non può essere superiore a 5!',
  Card: 'Card',
  CodFis: 'Codice Fiscale',
  Number: 'N°:',
  Telnumber: '+39 011 19 116 039',
  Assisemail: 'assistenza@mypass.cc',
  Cvv: 'Codice CVV',
  Confirmbymail: 'Conferma via Email',
  Resendb: 'Reinvia',
  Changee: 'Modifica Email',
  Changeeua: 'Modifica e-mail',
  Insertynmail: 'Inserisci la tua nuova Email',
  Insertynmailua: 'Inserisci la tua nuova e-mail',
  Welcome: 'Benvenuto nel mondo MyPass Sci',
  Later: 'Configura le tue card successivamente',
  Passrecovery: 'Recupera password',
  setPassword: 'Creare password',
  Resetpass: 'Inserisci la tua e-mail per reimpostare la password',
  setPassText: 'Inserisci la tua e-mail per impostare la password',
  Sendagain: 'Inviami nuovamente il codice identificativo',
  Passchanged: 'Password modificata correttamente!',
  Changeinfo: "Puoi modificare successivamente le tue informazioni nell'Area Utente.",
  Gotologin: 'Vai alla Login',
  PrivacyCheck1: 'Iscrivendoti accetti i ',
  PrivacyCheck2: 'di My Pass',
  And: 'e',
  PrivacyPolicy: 'Privacy Policy',
  Purchasedone: 'ACQUISTO EFFETTUATO CON SUCCESSO!',
  Whenreceive: '',
  currency: '€',
  hour: 'H',
  Purchase: 'Acquista',
  Wheretoski: 'Dove vai a sciare?',
  Shipadd: 'Indirizzo di spedizione',
  Bypriority: 'Le card saranno spedite all’indirizzo fornito in',
  Fourdays: 'quattro giorni lavorativi',
  Wheretoreceive: 'Dove vuoi ritirare la card?',
  Uploadrequested: 'Carica dati richiesti',
  Identificationcard: "Carta d'identità",
  Identificationcard_nodoc: 'Documento di riconoscimento',
  AlreadyUploaded: 'Già caricato',
  Drivinglicense: 'Patente di guida',
  Passport: 'Passaporto',
  Recphoto: 'Foto riconoscibile a viso scoperto del titolare della card',
  Childiscount: 'Acconsento al trattamento dei dati personali di mio figlio/a, o minore di cui sono tutore, da parte di MYPASS, allo scopo di fruire delle tariffe agevolate previste.',
  Uploadfront: 'Carica il fronte',
  Uploadback: 'Carica il retro',
  Uploadfirst: 'Carica la prima pagina interna',
  At: 'Presso',
  Street: 'Via',
  Streetnum: 'N° Civico',
  City: 'Città',
  Postalcode: 'Cap',
  Province: 'Provincia',
  Country: 'Stato',
  Insertpayinfo: 'Inserisci dati di pagamento',
  Pay: 'Paga',
  Nameoncard: 'Nome sulla carta',
  Downloadapp: 'SCARICA L’APP PER ACCEDERE ALLA TUA AREA UTENTE',
  Downloadnow: 'Scopri tutte le nuove funzionalità presenti nella nuova applicazione, scaricala ora!',
  Conditions: 'Condizioni d’uso',
  Terms: 'Termini d’uso',
  Andthe: 'e l’',
  Privacydisclaim: 'Informativa Privacy',
  Disclaimer: 'Informativa',
  Privacy: 'Privacy',
  Mandatory: '(consenso obbligatorio).',
  Accepti: 'Accetto i',
  Insertcardcode: 'Inserisci il codice della tua card',
  Insertback: 'Inserisci il codice che trovi sul retro della tua card',
  Codenum: 'Numero codice',
  Informskidata: 'La tua card risulta essere Skidata. Ti informiamo che se vuoi andare ad Andalo Paganella o Monte Bondone devi richiedere la card specifica successivamente.',
  Informaxess: 'La tua card risulta essere Axess. Ti informiamo che se vuoi andare in tutti gli altri comprensori convenzionati MyPass devi richiedere la card specifica successivamente.',
  Setupcard: 'Configura la tua card',
  Ifnotedit: 'Se non sei il titolare della card modifica i dati',
  InfoCannotBeEdited: 'Le informazioni non possono essere modificate quando aggiungi la seconda carta',
  Subscription: 'Iscrizione annuale a MyPassSci,',
  Valid365: 'valida 365 giorni dall’attivazione, compresa spedizione card a domicilio se richiesta.',
  Needupload: 'Dovrai caricare un documento di identità e foto.',
  Holder: 'Titolare',
  State: 'Stato',
  Cardnumber: 'N° Card',
  Inship: 'In spedizione',
  Removecard: 'Rimuovi card',
  Discountcode: 'Hai dei codici sconto?',
  Insertdiscount: 'Inserisci qui il tuo codice sconto',
  Purchasediscount: 'Acquista con codice sconto',
  Skipurchase: 'Salta e acquista',
  Total: 'TOTALE',
  Summary: 'Riepilogo',
  Operationcompleted: 'Operazione avvenuta con successo!',
  Logout: 'Logout',
  YouCannotBuyThisCard: "Hai già questo tipo di carta! Si prega di provare con l'altra",
  CartExsistMessage: "Ci risulta che stavi già comprando delle card. Vuoi continuare l'acquisto o svuotare il carrello?",
  TobeCollected: 'Da ritirare',
  CardExits: 'Attenzione, questo sciatore ha già una card di questo tipo',
  Passleast: '(La password deve essere di almeno 8 caratteri)',
  AccountDeleted: 'ACCOUNT ELIMINATO!',
  AccountDeleted_msg: 'Il tuo account è stato eliminato correttamente.',
  DocsUploaded: 'I tuoi documenti sono stati caricati correttamente e saranno validati al più presto',
  ProfilePhotoChanged: 'La tua foto è stata caricata correttamente',
  Finalprice: 'PREZZO FINALE',
  EmailSentSuccessfully: 'Email inviata con successo! Controlla la tua casella di posta',
  EmailChangedSuccessfully: 'Email cambiata con successo! Controlla la tua casella di posta',
  cantcloseEmailForm: 'Procedendo sarà interrotta la registrazione. Sei sicuro di voler continuare?',
  removeCCTitle: 'Sei sicuro di voler rimuovere la tua carta di credito?',
  removeCCNotice: 'Ricordati che devi avere una carta di credito valida inserita per poter sciare',
  Remember: 'Ricordati di caricare la tua foto se scii più di 8 giorni consecutivi',
  Deleteimage: "Vuoi davvero eliminare questa immagine e caricarne un'altra?",
  Exit: 'Ecsi',
  Close: 'Chiudi',
  UpdateInfo: 'Modificare',

  CCNumberIsWrong: 'Il numero della carta di credito non è corretto',
  CCHolderNameIsWrong: 'Il nome del proprietario della carta di credito non è corretto',
  CCCvvIsWrong: 'Il codice di controllo della carta di credito non è corretto',

  loginbyFB: 'Accedi con Facebook',
  loginbyGoogle: 'Accedi con Google',
  loginbyApple: 'Accedi con Apple',

  CCNumberLabel: 'Numero di carta',
  cvvDescription: 'Il codice a 3 cifre CVV si trova sul retro della carta.',
  completeYourData: 'Completa i tuoi dati',
  completeYourData_2: 'Per poter usufruire del servizio di MyPass Ski, compila i campi richiesti.',

  standardPost: 'Spedizione standard a domicilio',
  withinFourDays: 'entro quattro giorni lavorativi',
  shippingCost: 'Costo spedizione',
  discount: 'Sconto',
  cardValidateError: 'Codice non valido, verificane la correttezza!',
  cardValidationSysError: "Errore di sistema. Riprova e se il problema persiste contatta l'assistenza.",
  cardValidationProviderError: "Non è stato possibile contattare il fornitore del servizio. Riprova più tardi o contatta l'assistenza.",

  issueWithSella: "Il nostro partner bancario sta rilevando in queste ore alcune problematiche sui propri server. Per questo motivo il pagamento effettuato da computer desktop non andrà a buon fine. Ti invitiamo ad effettuare il pagamento dall'app Mypass ski",
  moreInfo: 'Più informazioni',
  deletingTheSkier: 'Sei sicuro di voler eliminare questo sciatore?',
  pagenotfound: 'Ops! La pagina che stai cercando non è stata trovata ...',
  timeoutMessage: "Siamo spiacenti! Stiamo affrontando alcune difficoltà tecniche. Non ci vorrà molto, riprova più tardi. Se il problema persiste, contatta l'assistenza.",
  reserveYourAccess: 'Prenota il tuo ingresso in pista',
  goToWallet: 'Le tue prenotazioni',
  proofOfAddress: "Prego caricare un documento valido a dimostrare l'effettiva residenza presso il codice postale indicato e premere Carica",
  back: 'Indietro',
  InsertYourData: 'Inserisci i tuoi dati',
  ConfigureYourKeycard: 'Configura la tua Keycard',
  PaymentDetails: 'Dettagli del pagamento',
  StartSkiing: 'Comincia a sciare!',
  NumberCard: 'Numero della carta'
}



// WEBPACK FOOTER //
// ./src/assets/locales/it.js